import { Component, ChangeDetectorRef, HostListener } from '@angular/core';
import { OAuthService, ValidationHandler, ValidationParams, AuthConfig } from 'angular-oauth2-oidc';
import { getBaseUrl, getOauthOidcIssuer } from 'src/main-url';
import { LoadingService } from './services/loading.service';
import { LoginService } from './services/login.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  loading: any;
  private unsubscribe: Subject<any> = new Subject();

  @HostListener('window:beforeunload', ['$event'])
     beforeUnloadHander(event) {
    //Check if localStorage avaialble if not logout
    if (!localStorage.getItem('loggedInUser')) {
      this.loginService.logout();
    }
  }

  constructor(
    private oauthService: OAuthService,
    private loadingService: LoadingService,
    private loginService: LoginService,
    private cdRef: ChangeDetectorRef) {
    //this.configureOAuth();
    this.configureWithNewConfigApi();
  }

  ngOnInit() {

    this.loading = this.loadingService.currentLoading
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(loading => {
      this.loading = loading;
      this.cdRef.detectChanges();
    });

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private configureWithNewConfigApi() {
    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new NullValidationHandler(); //new JwksValidationHandler();
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

}

//SECURITY: This code is required in order for OIDC to work, but should never be called in the current configuration.
//SECURITY: If this code is reached, then a proper ValidationHandler needs to be provided to avoid vulnerabilities or an alternate configuration used.
export class NullValidationHandler implements ValidationHandler {
  validateSignature(validationParams: ValidationParams): Promise<any> {
    throw new Error("SECURITY Exception - this code should not have been reached (validateSignature).");
  }
  validateAtHash(validationParams: ValidationParams): Promise<boolean> {
    throw new Error("SECURITY Exception - this code should not have been reached (validateHash).");
  }
}

export const authConfig: AuthConfig = {
  // Url of the Identity Provider.
  issuer: getOauthOidcIssuer(),

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + '/index.html',

  // URL of the SPA to redirect the user after silent refresh
  //silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'openid profile email',

  // silentRefreshShowIFrame: true,

  showDebugInformation: true,

  sessionChecksEnabled: false
};
